import React from 'react';

import { Badge, BadgeProps } from '@mantine/core';

interface DroxyBadgeProps extends BadgeProps {
  children: React.ReactNode;
}

export function DroxyBadge({ children, ...badgeProps }: DroxyBadgeProps) {
  return (
    <Badge
      variant="outline"
      size="sm"
      radius="xl"
      px={12}
      tt="capitalize"
      sx={(theme) => ({
        borderColor: theme.colors.gray[3],
        color: theme.colors.gray[7]
      })}
      {...badgeProps}>
      {children}
    </Badge>
  );
}
